import React from 'react';

export default function DeleteIcon() {
  return (
    <svg width="34" height="44" viewBox="0 0 34 44" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.42857 38.8571C2.42857 41.5286 4.61429 43.7143 7.28571 43.7143H26.7143C29.3857 43.7143 31.5714 41.5286 31.5714 38.8571V9.71429H2.42857V38.8571ZM34 2.42857H25.5L23.0714 0H10.9286L8.5 2.42857H0V7.28571H34V2.42857Z" />
    </svg>
  );
}
